import { URL } from "../environment/variables";

export const getInfoTextService = async () => {

    try{
        const response = await fetch(`${URL}/cms/obtenerconfiguraciones/F0C81F81-0ABD-4988-8C3B-838C1CB3859B`, {
        // const response = await fetch(`${URL}/cms/obtenerconfiguraciones/4FB30AC7-53FB-43A6-886E-2A067D0263BF`, {
            mode: 'cors',
            method: 'GET',
            headers:{
                'Accept': '*/*',
            }
        })
        const json = await response.json()
        return json
    }catch(err){
        console.log(err)
    }

}